import React from 'react';
import { FaGlobe, FaLinkedin, FaEnvelope, FaPhone, FaUser } from 'react-icons/fa';
import CustomImage from '../common/CustomImage';
import './CompanyInfo.css';

const CompanyInfo = ({ company, contactInfo }) => {
  if (!company) return null;

  const formatContactInfo = (contactInfo) => {
    if (!contactInfo) return null;

    return (
      <div className="contact-info">
        <h4>Contact Information</h4>
        <div className="contact-items">
          {contactInfo.contactPerson && (
            <div className="contact-item">
              <FaUser />
              <span><strong>Contact Person:</strong> {contactInfo.contactPerson}</span>
            </div>
          )}
          {contactInfo.email && (
            <div className="contact-item">
              <FaEnvelope />
              <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
            </div>
          )}
          {contactInfo.phone && (
            <div className="contact-item">
              <FaPhone />
              <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="company-info-card">
      <div className="company-header">
        <div className="company-logo-container">
          <CustomImage
            src={company.logo}
            alt={company.name}
            fallback="/images/company-placeholder.png"
            className="company-logo"
          />
        </div>
        <div className="company-details">
          <h3>{company.name}</h3>
          {company.website && (
            <a 
              href={company.website} 
              target="_blank" 
              rel="noopener noreferrer"
              className="company-website"
            >
              <FaGlobe />
              Visit Website
            </a>
          )}
          {company.sameAs && (
            <a 
              href={company.sameAs} 
              target="_blank" 
              rel="noopener noreferrer"
              className="company-linkedin"
            >
              <FaLinkedin />
              LinkedIn
            </a>
          )}
        </div>
      </div>
      
      {formatContactInfo(contactInfo)}
    </div>
  );
};

export default CompanyInfo; 